import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
const AVAILABILITY = [['few-minutes', 'A few minutes most days'], ['hour-week', 'About an hour a week'], ['several-hours', 'Several hours a week']];

/** /moderators - what moderating involves, and the application form (members only). */
export default class ModeratorPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Become a moderator');
    let preselect = '';
    try {
      // "?community=" (never "?tag=": Flarum hands URL parameters to the page, and "tag" is reserved in Mithril)
      preselect = m.route.param('community') || '';
    } catch (e) {}
    this.form = {
      tags: preselect ? [preselect] : [],
      motivation: '',
      experience: '',
      availability: '',
      agree: false
    };
    this.sending = false;
    this.sent = false;
    this.error = null;
  }
  tags() {
    // Top-level tags people can moderate, in forum order
    return (app.store.all('tags') || []).filter(t => !t.parent() && !(t.isHidden && t.isHidden())).sort((a, b) => (a.position() ?? 999) - (b.position() ?? 999));
  }
  view() {
    return m("div", {
      className: "VouchaModPage container"
    }, m("header", {
      className: "VouchaModPage-hero"
    }, m("i", {
      className: "fas fa-user-shield",
      "aria-hidden": "true"
    }), m("div", null, m("h1", null, "Help run Voucha"), m("p", null, "Moderators keep each community useful, accurate and friendly. It's volunteer work, a few minutes a day, and you'll be shaping the conversations Nigerians at home and abroad rely on."))), m("div", {
      className: "VouchaModPage-grid"
    }, m("section", {
      className: "VouchaModPage-card"
    }, m("h2", null, "What moderators do"), m("ul", null, m("li", null, "Welcome new members and point them to the right place"), m("li", null, "Keep discussions on topic, and merge or move duplicates"), m("li", null, "Remove spam, scams and posts that break the guidelines"), m("li", null, "Flag misleading claims, especially about money and immigration"), m("li", null, "Pin the most useful discussions in your tag"))), m("section", {
      className: "VouchaModPage-card"
    }, m("h2", null, "What we look for"), m("ul", null, m("li", null, "You already take part and know the community"), m("li", null, "You're fair, calm and respectful, even in heated threads"), m("li", null, "You can spare a little time most weeks"), m("li", null, "You'll follow the community guidelines yourself")))), this.formSection());
  }
  formSection() {
    if (!app.session.user) {
      return m("section", {
        className: "VouchaModPage-card VouchaModPage-form"
      }, m("h2", null, "Apply"), m("p", null, "You need a Voucha account to apply, so we can see how you take part. Log in or sign up using the buttons at the top of the page."));
    }
    if (this.sent) {
      return m("section", {
        className: "VouchaModPage-card VouchaModPage-form is-done"
      }, m("h2", null, "Thanks for applying"), m("p", null, "We've received your application and sent you a confirmation email. We read every one and will be in touch."));
    }
    const f = this.form;
    const toggle = (slug, on) => f.tags = on ? [...f.tags.filter(t => t !== slug), slug] : f.tags.filter(t => t !== slug);
    return m("section", {
      className: "VouchaModPage-card VouchaModPage-form"
    }, m("h2", null, "Apply"), m("div", {
      className: "VouchaModPage-field"
    }, m("label", null, "Which communities would you like to help run?"), m("div", {
      className: "VouchaModPage-tags"
    }, this.tags().map(t => m("label", {
      className: 'VouchaModPage-tag' + (f.tags.includes(t.slug()) ? ' is-on' : '')
    }, m("input", {
      type: "checkbox",
      checked: f.tags.includes(t.slug()),
      onchange: e => toggle(t.slug(), e.target.checked)
    }), t.icon() ? m("i", {
      className: t.icon(),
      "aria-hidden": "true"
    }) : null, " ", t.name())))), m("div", {
      className: "VouchaModPage-field"
    }, m("label", {
      for: "vmod-why"
    }, "Why would you like to moderate?"), m("textarea", {
      id: "vmod-why",
      className: "FormControl",
      rows: "4",
      maxlength: "3000",
      value: f.motivation,
      oninput: e => f.motivation = e.target.value
    })), m("div", {
      className: "VouchaModPage-field"
    }, m("label", {
      for: "vmod-exp"
    }, "Relevant experience (optional)"), m("textarea", {
      id: "vmod-exp",
      className: "FormControl",
      rows: "3",
      maxlength: "3000",
      placeholder: "Other communities you've helped run, or your background in these communities",
      value: f.experience,
      oninput: e => f.experience = e.target.value
    })), m("div", {
      className: "VouchaModPage-field"
    }, m("label", {
      for: "vmod-time"
    }, "How much time can you give?"), m("select", {
      id: "vmod-time",
      className: "FormControl",
      value: f.availability,
      onchange: e => f.availability = e.target.value
    }, m("option", {
      value: ""
    }, "Choose one"), AVAILABILITY.map(([v, label]) => m("option", {
      value: v
    }, label)))), m("label", {
      className: "VouchaModPage-agree"
    }, m("input", {
      type: "checkbox",
      checked: f.agree,
      onchange: e => f.agree = e.target.checked
    }), " I'll follow Voucha's community guidelines and moderate fairly."), this.error ? m("p", {
      className: "VouchaModPage-error"
    }, this.error) : null, m(Button, {
      className: "Button Button--primary",
      loading: this.sending,
      onclick: () => this.submit()
    }, "Send application"));
  }
  async submit() {
    this.sending = true;
    this.error = null;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/voucha-ads/moderator-applications',
        body: this.form,
        errorHandler: () => {}
      });
      this.sent = true;
      window.scrollTo(0, 0);
    } catch (e) {
      this.error = e?.response?.message || "That didn't send. Please try again.";
    }
    this.sending = false;
    m.redraw();
  }
}
flarum.reg.add('voucha-ads', 'forum/components/ModeratorPage', ModeratorPage);